import React from 'react';
import { COLUMN_TEMPLATE, HEADER_HEIGHT } from './productGridConfig';

const thStyle = {
  padding: '0.3rem 0.15rem',
  fontWeight: '600',
  color: 'var(--text-secondary)',
  fontSize: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none',
  cursor: 'pointer',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
};

const SortIcon = ({ active, direction }) => {
  if (!active) return <span style={{ opacity: 0.3, marginLeft: '2px' }}>↕</span>;
  return <span style={{ marginLeft: '2px' }}>{direction === 'asc' ? '↑' : '↓'}</span>;
};

const ProductsTableHeader = ({
  sortColumn, sortDirection, onSort,
  selectedCount, totalCount, onSelectAll
}) => (
  <div style={{
    display: 'grid',
    gridTemplateColumns: COLUMN_TEMPLATE,
    height: HEADER_HEIGHT,
    backgroundColor: 'var(--bg)',
    borderBottom: '2px solid var(--border)',
    position: 'sticky',
    top: 0,
    zIndex: 2
  }}>
    <div style={{ ...thStyle, cursor: 'default' }}>
      <input
        type="checkbox"
        checked={selectedCount === totalCount && totalCount > 0}
        onChange={onSelectAll}
        style={{ width: '13px', height: '13px', margin: 0 }}
      />
    </div>
    <div style={{ ...thStyle, fontSize: '9px', cursor: 'default' }}>Lp</div>
    <div style={thStyle} onClick={() => onSort('id')}>
      ID<SortIcon active={sortColumn === 'id'} direction={sortDirection} />
    </div>
    <div style={{ ...thStyle, justifyContent: 'flex-start', padding: '0.3rem', minWidth: 0 }} onClick={() => onSort('nazwa')}>
      Produkt<SortIcon active={sortColumn === 'nazwa'} direction={sortDirection} />
    </div>
    <div style={thStyle} onClick={() => onSort('kod_produktu')}>
      Kod/EAN<SortIcon active={sortColumn === 'kod_produktu'} direction={sortDirection} />
    </div>
    <div style={thStyle} onClick={() => onSort('kategoria')}>
      Kategoria<SortIcon active={sortColumn === 'kategoria'} direction={sortDirection} />
    </div>
    <div style={{ ...thStyle, justifyContent: 'flex-end', padding: '0.3rem' }} onClick={() => onSort('cena')}>
      Cena spr.<SortIcon active={sortColumn === 'cena'} direction={sortDirection} />
    </div>
    <div style={{ ...thStyle, justifyContent: 'flex-end', padding: '0.3rem' }} onClick={() => onSort('cena_zakupu')}>
      Cena zak.<SortIcon active={sortColumn === 'cena_zakupu'} direction={sortDirection} />
    </div>
    <div style={{ ...thStyle, cursor: 'default' }}>Marża</div>
    <div style={thStyle} onClick={() => onSort('stawka_vat')}>
      VAT<SortIcon active={sortColumn === 'stawka_vat'} direction={sortDirection} />
    </div>
    <div style={{ ...thStyle, cursor: 'default' }}>Akcje</div>
  </div>
);

export default React.memo(ProductsTableHeader);
